import { __decorate } from 'tslib';
import { RIGHT_ARROW, LEFT_ARROW } from '@angular/cdk/keycodes';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, forwardRef, Optional, ViewChild, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i1$1 from 'ng-zorro-antd/core/config';
import { WithConfig } from 'ng-zorro-antd/core/config';
import * as i3 from 'ng-zorro-antd/core/services';
import { NzDestroyService } from 'ng-zorro-antd/core/services';
import { InputBoolean, InputNumber } from 'ng-zorro-antd/core/util';
import * as i4 from 'ng-zorro-antd/tooltip';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import * as i1 from 'ng-zorro-antd/icon';
import { NzIconModule } from 'ng-zorro-antd/icon';
import * as i2 from '@angular/cdk/bidi';
const _c0 = ["nz-rate-item", ""];
const _c1 = a0 => ({
  $implicit: a0
});
function NzRateItemComponent_ng_template_1_Template(rf, ctx) {}
function NzRateItemComponent_ng_template_3_Template(rf, ctx) {}
function NzRateItemComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
  }
}
const _c2 = ["ulElement"];
function NzRateComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 2)(1, "div", 3);
    i0.ɵɵlistener("itemHover", function NzRateComponent_For_3_Template_div_itemHover_1_listener($event) {
      const $index_r3 = i0.ɵɵrestoreView(_r2).$index;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onItemHover($index_r3, $event));
    })("itemClick", function NzRateComponent_For_3_Template_div_itemClick_1_listener($event) {
      const $index_r3 = i0.ɵɵrestoreView(_r2).$index;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onItemClick($index_r3, $event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const $index_r3 = ctx.$index;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r3.starStyleArray[$index_r3] || "")("nzTooltipTitle", ctx_r3.nzTooltips[$index_r3]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("allowHalf", ctx_r3.nzAllowHalf)("character", ctx_r3.nzCharacter)("index", $index_r3);
  }
}
let NzRateItemComponent = /*#__PURE__*/(() => {
  class NzRateItemComponent {
    constructor() {
      this.index = 0;
      this.allowHalf = false;
      this.itemHover = new EventEmitter();
      this.itemClick = new EventEmitter();
    }
    hoverRate(isHalf) {
      this.itemHover.next(isHalf && this.allowHalf);
    }
    clickRate(isHalf) {
      this.itemClick.next(isHalf && this.allowHalf);
    }
    static {
      this.ɵfac = function NzRateItemComponent_Factory(t) {
        return new (t || NzRateItemComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzRateItemComponent,
        selectors: [["", "nz-rate-item", ""]],
        inputs: {
          character: "character",
          index: "index",
          allowHalf: "allowHalf"
        },
        outputs: {
          itemHover: "itemHover",
          itemClick: "itemClick"
        },
        exportAs: ["nzRateItem"],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        attrs: _c0,
        decls: 6,
        vars: 8,
        consts: [["defaultCharacter", ""], [1, "ant-rate-star-second", 3, "mouseover", "click"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ant-rate-star-first", 3, "mouseover", "click"], ["nz-icon", "", "nzType", "star", "nzTheme", "fill"]],
        template: function NzRateItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("mouseover", function NzRateItemComponent_Template_div_mouseover_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              ctx.hoverRate(false);
              return i0.ɵɵresetView($event.stopPropagation());
            })("click", function NzRateItemComponent_Template_div_click_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.clickRate(false));
            });
            i0.ɵɵtemplate(1, NzRateItemComponent_ng_template_1_Template, 0, 0, "ng-template", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 3);
            i0.ɵɵlistener("mouseover", function NzRateItemComponent_Template_div_mouseover_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              ctx.hoverRate(true);
              return i0.ɵɵresetView($event.stopPropagation());
            })("click", function NzRateItemComponent_Template_div_click_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.clickRate(true));
            });
            i0.ɵɵtemplate(3, NzRateItemComponent_ng_template_3_Template, 0, 0, "ng-template", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, NzRateItemComponent_ng_template_4_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const defaultCharacter_r2 = i0.ɵɵreference(5);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.character || defaultCharacter_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c1, ctx.index));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.character || defaultCharacter_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c1, ctx.index));
          }
        },
        dependencies: [NgTemplateOutlet, NzIconModule, i1.NzIconDirective],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  __decorate([InputBoolean()], NzRateItemComponent.prototype, "allowHalf", void 0);
  return NzRateItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NZ_CONFIG_MODULE_NAME = 'rate';
let NzRateComponent = /*#__PURE__*/(() => {
  class NzRateComponent {
    get nzValue() {
      return this._value;
    }
    set nzValue(input) {
      if (this._value === input) {
        return;
      }
      this._value = input;
      this.hasHalf = !Number.isInteger(input);
      this.hoverValue = Math.ceil(input);
    }
    constructor(nzConfigService, ngZone, renderer, cdr, directionality, destroy$) {
      this.nzConfigService = nzConfigService;
      this.ngZone = ngZone;
      this.renderer = renderer;
      this.cdr = cdr;
      this.directionality = directionality;
      this.destroy$ = destroy$;
      this._nzModuleName = NZ_CONFIG_MODULE_NAME;
      this.nzAllowClear = true;
      this.nzAllowHalf = false;
      this.nzDisabled = false;
      this.nzAutoFocus = false;
      this.nzCount = 5;
      this.nzTooltips = [];
      this.nzOnBlur = new EventEmitter();
      this.nzOnFocus = new EventEmitter();
      this.nzOnHoverChange = new EventEmitter();
      this.nzOnKeyDown = new EventEmitter();
      this.classMap = {};
      this.starArray = [];
      this.starStyleArray = [];
      this.dir = 'ltr';
      this.hasHalf = false;
      this.hoverValue = 0;
      this.isFocused = false;
      this._value = 0;
      this.isNzDisableFirstChange = true;
      this.onChange = () => null;
      this.onTouched = () => null;
    }
    ngOnChanges(changes) {
      const {
        nzAutoFocus,
        nzCount,
        nzValue
      } = changes;
      if (nzAutoFocus && !nzAutoFocus.isFirstChange()) {
        const el = this.ulElement.nativeElement;
        if (this.nzAutoFocus && !this.nzDisabled) {
          this.renderer.setAttribute(el, 'autofocus', 'autofocus');
        } else {
          this.renderer.removeAttribute(el, 'autofocus');
        }
      }
      if (nzCount) {
        this.updateStarArray();
      }
      if (nzValue) {
        this.updateStarStyle();
      }
    }
    ngOnInit() {
      this.nzConfigService.getConfigChangeEventForComponent(NZ_CONFIG_MODULE_NAME).pipe(takeUntil(this.destroy$)).subscribe(() => this.cdr.markForCheck());
      this.directionality.change.pipe(takeUntil(this.destroy$)).subscribe(direction => {
        this.dir = direction;
        this.cdr.detectChanges();
      });
      this.dir = this.directionality.value;
      this.ngZone.runOutsideAngular(() => {
        fromEvent(this.ulElement.nativeElement, 'focus').pipe(takeUntil(this.destroy$)).subscribe(event => {
          this.isFocused = true;
          if (this.nzOnFocus.observers.length) {
            this.ngZone.run(() => this.nzOnFocus.emit(event));
          }
        });
        fromEvent(this.ulElement.nativeElement, 'blur').pipe(takeUntil(this.destroy$)).subscribe(event => {
          this.isFocused = false;
          if (this.nzOnBlur.observers.length) {
            this.ngZone.run(() => this.nzOnBlur.emit(event));
          }
        });
      });
    }
    onItemClick(index, isHalf) {
      if (this.nzDisabled) {
        return;
      }
      this.hoverValue = index + 1;
      const actualValue = isHalf ? index + 0.5 : index + 1;
      if (this.nzValue === actualValue) {
        if (this.nzAllowClear) {
          this.nzValue = 0;
          this.onChange(this.nzValue);
        }
      } else {
        this.nzValue = actualValue;
        this.onChange(this.nzValue);
      }
      this.updateStarStyle();
    }
    onItemHover(index, isHalf) {
      if (this.nzDisabled || this.hoverValue === index + 1 && isHalf === this.hasHalf) {
        return;
      }
      this.hoverValue = index + 1;
      this.hasHalf = isHalf;
      this.nzOnHoverChange.emit(this.hoverValue);
      this.updateStarStyle();
    }
    onRateLeave() {
      this.hasHalf = !Number.isInteger(this.nzValue);
      this.hoverValue = Math.ceil(this.nzValue);
      this.updateStarStyle();
    }
    focus() {
      this.ulElement.nativeElement.focus();
    }
    blur() {
      this.ulElement.nativeElement.blur();
    }
    onKeyDown(e) {
      const oldVal = this.nzValue;
      if (e.keyCode === RIGHT_ARROW && this.nzValue < this.nzCount) {
        this.nzValue += this.nzAllowHalf ? 0.5 : 1;
      } else if (e.keyCode === LEFT_ARROW && this.nzValue > 0) {
        this.nzValue -= this.nzAllowHalf ? 0.5 : 1;
      }
      if (oldVal !== this.nzValue) {
        this.onChange(this.nzValue);
        this.nzOnKeyDown.emit(e);
        this.updateStarStyle();
        this.cdr.markForCheck();
      }
    }
    updateStarArray() {
      this.starArray = Array(this.nzCount).fill(0).map((_, i) => i);
      this.updateStarStyle();
    }
    updateStarStyle() {
      this.starStyleArray = this.starArray.map(i => {
        const prefix = 'ant-rate-star';
        const value = i + 1;
        return {
          [`${prefix}-full`]: value < this.hoverValue || !this.hasHalf && value === this.hoverValue,
          [`${prefix}-half`]: this.hasHalf && value === this.hoverValue,
          [`${prefix}-active`]: this.hasHalf && value === this.hoverValue,
          [`${prefix}-zero`]: value > this.hoverValue,
          [`${prefix}-focused`]: this.hasHalf && value === this.hoverValue && this.isFocused
        };
      });
    }
    writeValue(value) {
      this.nzValue = value || 0;
      this.updateStarArray();
      this.cdr.markForCheck();
    }
    setDisabledState(isDisabled) {
      this.nzDisabled = this.isNzDisableFirstChange && this.nzDisabled || isDisabled;
      this.isNzDisableFirstChange = false;
      this.cdr.markForCheck();
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    static {
      this.ɵfac = function NzRateComponent_Factory(t) {
        return new (t || NzRateComponent)(i0.ɵɵdirectiveInject(i1$1.NzConfigService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.Directionality, 8), i0.ɵɵdirectiveInject(i3.NzDestroyService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzRateComponent,
        selectors: [["nz-rate"]],
        viewQuery: function NzRateComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c2, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ulElement = _t.first);
          }
        },
        inputs: {
          nzAllowClear: "nzAllowClear",
          nzAllowHalf: "nzAllowHalf",
          nzDisabled: "nzDisabled",
          nzAutoFocus: "nzAutoFocus",
          nzCharacter: "nzCharacter",
          nzCount: "nzCount",
          nzTooltips: "nzTooltips"
        },
        outputs: {
          nzOnBlur: "nzOnBlur",
          nzOnFocus: "nzOnFocus",
          nzOnHoverChange: "nzOnHoverChange",
          nzOnKeyDown: "nzOnKeyDown"
        },
        exportAs: ["nzRate"],
        standalone: true,
        features: [i0.ɵɵProvidersFeature([NzDestroyService, {
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => NzRateComponent),
          multi: true
        }]), i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 6,
        consts: [["ulElement", ""], [1, "ant-rate", 3, "keydown", "mouseleave", "ngClass", "tabindex"], ["nz-tooltip", "", 1, "ant-rate-star", 3, "ngClass", "nzTooltipTitle"], ["nz-rate-item", "", 3, "itemHover", "itemClick", "allowHalf", "character", "index"]],
        template: function NzRateComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "ul", 1, 0);
            i0.ɵɵlistener("keydown", function NzRateComponent_Template_ul_keydown_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              ctx.onKeyDown($event);
              return i0.ɵɵresetView($event.preventDefault());
            })("mouseleave", function NzRateComponent_Template_ul_mouseleave_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              ctx.onRateLeave();
              return i0.ɵɵresetView($event.stopPropagation());
            });
            i0.ɵɵrepeaterCreate(2, NzRateComponent_For_3_Template, 2, 5, "li", 2, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("ant-rate-disabled", ctx.nzDisabled)("ant-rate-rtl", ctx.dir === "rtl");
            i0.ɵɵproperty("ngClass", ctx.classMap)("tabindex", ctx.nzDisabled ? -1 : 1);
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.starArray);
          }
        },
        dependencies: [NgClass, NzToolTipModule, i4.NzTooltipDirective, NzRateItemComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  __decorate([WithConfig(), InputBoolean()], NzRateComponent.prototype, "nzAllowClear", void 0);
  __decorate([WithConfig(), InputBoolean()], NzRateComponent.prototype, "nzAllowHalf", void 0);
  __decorate([InputBoolean()], NzRateComponent.prototype, "nzDisabled", void 0);
  __decorate([InputBoolean()], NzRateComponent.prototype, "nzAutoFocus", void 0);
  __decorate([InputNumber()], NzRateComponent.prototype, "nzCount", void 0);
  return NzRateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzRateModule = /*#__PURE__*/(() => {
  class NzRateModule {
    static {
      this.ɵfac = function NzRateModule_Factory(t) {
        return new (t || NzRateModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NzRateModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [NzRateComponent, NzRateItemComponent]
      });
    }
  }
  return NzRateModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzRateComponent, NzRateItemComponent, NzRateModule };
